import { ProjectActions, InitiativeActions } from "../actions";
import { Project } from "../stores";
import Immutable from "seamless-immutable";
import findIndex from "lodash.findindex";
import map from "lodash.map";
import forEach from "lodash.foreach";
import moment from "moment";

const initialState = Immutable(Project);

export function project(store = initialState, action) {
  switch (action.type) {
    case ProjectActions.GetBudgetVoteProjectsAction.Request:
    case ProjectActions.FetchProjectsByTypeAction.Request: {
      return store.merge({
        isProjectListLoading: true,
      });
    }
    case ProjectActions.GetBudgetVoteProjectsAction.Failure:
    case ProjectActions.FetchProjectsByTypeAction.Failure: {
      return store.merge({
        isProjectListLoading: false,
      });
    }
    case ProjectActions.GetBudgetVoteProjectsAction.Success:
    case ProjectActions.FetchProjectsByTypeAction.Success: {
      return store.merge({
        projects: action.payload.items,
        project: null,
        isProjectListLoading: false,
        totalProjects: action.payload.totalItems,
      });
    }
    case ProjectActions.FetchArchiveProjectsByTypeAction.Request: {
      return store.merge({
        isArchiveProjectLoading: true,
      });
    }
    case ProjectActions.FetchArchiveProjectsByTypeAction.Success: {
      return store.merge({
        archiveProjects: action.payload.items,
        project: null,
        isArchiveProjectLoading: false,
        totalArchiveProjects: action.payload.totalItems,
      });
    }
    case ProjectActions.FetchArchiveProjectsByTypeAction.Failure: {
      return store.merge({
        isArchiveProjectLoading: false,
      });
    }
    case ProjectActions.GetProjectAction.Request: {
      return store.merge({ isProjectLoading: true });
    }
    case ProjectActions.AddProjectOpinionAction.Request:
    case ProjectActions.RemoveProjectOpinionAction.Request:
    case ProjectActions.AddCommentOpinionAction.Request:
    case ProjectActions.RemoveCommentOpinionAction.Request: {
      let opinionExecuting = Immutable.getIn(store, ["opinionExecuting"]);

      return store.merge({
        opinionExecuting: opinionExecuting.concat(action.payload.id),
      });
    }
    case ProjectActions.UpdateConsultationFormAction.Request: {
      let voteExecuting = Immutable.getIn(store, ["voteExecuting"]);
      let consultationFormIds = map(
        action.payload.consultationForms,
        (cf) => cf.id
      );

      return store.merge({
        voteExecuting: voteExecuting.concat(...consultationFormIds),
      });
    }
    case ProjectActions.UpdateConsultationFormAction.Failure: {
      let voteExecuting = getNewArray(store, action.payload, ["voteExecuting"]);

      return store.merge({
        voteExecuting: voteExecuting,
      });
    }
    case ProjectActions.AddProjectOpinionAction.Success:
    case ProjectActions.RemoveProjectOpinionAction.Success:
    case ProjectActions.AddCommentOpinionAction.Success:
    case ProjectActions.RemoveCommentOpinionAction.Success:
    case ProjectActions.SaveCommentAction.Success:
    case ProjectActions.GetProjectAction.Success:
    case InitiativeActions.CreateConsultationInitiativeAction.Success: {
      action.payload.dateFrom = moment(action.payload.dateFrom).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      action.payload.dateTo = moment(action.payload.dateTo).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      action.payload.comments.forEach((item) => {
        item.createdDate = moment(item.createdDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      if (action.payload.act != null) {
        action.payload.act.comments.forEach((item) => {
          item.createdDate = moment(item.createdDate).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        action.payload.act.childrens.forEach((item) => {
          item.comments.forEach((item) => {
            item.createdDate = moment(item.createdDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
        });
      }
      action.payload.consultationForms.forEach((item) => {
        item.voteFrom = moment(item.voteFrom).format("YYYY-MM-DD HH:mm:ss");
        item.voteTo = moment(item.voteTo).format("YYYY-MM-DD HH:mm:ss");
        item.categories.forEach((category) => {
          category.questions.forEach((question) => {
            question.answers.forEach((answer) => {
              answer.answerOptions.forEach((answerOption) => {
                answerOption.openDate = answerOption.openDate
                  ? moment(answerOption.openDate).format("YYYY-MM-DD HH:mm:ss")
                  : null;
              });
            });
          });
        });
      });

      let opinionExecuting = getNewArray(
        store,
        [action.payload.opinionActionId],
        ["opinionExecuting"]
      );

      return store.merge({
        project: action.payload,
        isProjectLoading: false,
        authorizeCodeGenerated: false,
        opinionExecuting: opinionExecuting,
      });
    }
    case ProjectActions.UpdateConsultationFormAction.Success: {
      const { project, consultationFormIds } = action.payload;

      project.dateFrom = moment(project.dateFrom).format("YYYY-MM-DD HH:mm:ss");
      project.dateTo = moment(project.dateTo).format("YYYY-MM-DD HH:mm:ss");
      project.comments.forEach((item) => {
        item.createdDate = moment(item.createdDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      if (project.act != null) {
        project.act.comments.forEach((item) => {
          item.createdDate = moment(item.createdDate).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        project.act.childrens.forEach((item) => {
          item.comments.forEach((item) => {
            item.createdDate = moment(item.createdDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
        });
      }
      project.consultationForms.forEach((item) => {
        item.voteFrom = moment(item.voteFrom).format("YYYY-MM-DD HH:mm:ss");
        item.voteTo = moment(item.voteTo).format("YYYY-MM-DD HH:mm:ss");
        item.categories.forEach((category) => {
          category.questions.forEach((question) => {
            question.answers.forEach((answer) => {
              answer.answerOptions.forEach((answerOption) => {
                answerOption.openDate = answerOption.openDate
                  ? moment(answerOption.openDate).format("YYYY-MM-DD HH:mm:ss")
                  : null;
              });
            });
          });
        });
      });
      let voteExecuting = getNewArray(store, consultationFormIds, [
        "voteExecuting",
      ]);

      let projectIndex = store.projects.findIndex(
        (item) => item.id === project.id
      );
      let projects = store.getIn(["projects"]);

      return store.merge({
        project: project,
        voteExecuting,
        // authorizeCodeGenerated: false,
        projects: projects
          .slice(0, projectIndex)
          .concat(project)
          .concat(projects.slice(projectIndex + 1)),
      });
    }
    case ProjectActions.GetProjectAction.Failure: {
      return store.merge({ isProjectLoading: false });
    }
    case ProjectActions.GetProjectHeaderAction.Request: {
      return store.merge({ isProjectLoading: true });
    }
    case ProjectActions.GetProjectHeaderAction.Success: {
      action.payload.dateFrom = moment(action.payload.dateFrom).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      action.payload.dateTo = moment(action.payload.dateTo).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      return store.merge({
        project: action.payload,
        isProjectLoading: false,
      });
    }
    case ProjectActions.GenerateNewAuthorizeCodeAction.Request: {
      return store.merge({
        authorizeCodeGenerated: false,
        isAuthorizeCodeGenerating: true,
      });
    }
    case ProjectActions.GenerateNewAuthorizeCodeAction.Failure: {
      return store.merge({
        authorizeCodeGenerated: false,
        isAuthorizeCodeGenerating: false,
      });
    }
    case ProjectActions.GenerateNewAuthorizeCodeAction.Success: {
      return store.merge({
        authorizeCodeGenerated: true,
        isAuthorizeCodeGenerating: false,
      });
    }
    default: {
      return store;
    }
  }
}

function getNewArray(store, objectIds, propertyName) {
  let executingArray = Immutable.getIn(store, propertyName);

  objectIds.forEach((objectId) => {
    let executingItemIndex = executingArray.findIndex((id) => id === objectId);

    if (executingItemIndex !== -1) {
      executingArray = executingArray.filter((id) => id !== objectId);
    }
  });

  return executingArray;
}
